import { render, staticRenderFns } from "./jclist.vue?vue&type=template&id=135d3d21&scoped=true&"
import script from "./jclist.vue?vue&type=script&lang=js&"
export * from "./jclist.vue?vue&type=script&lang=js&"
import style0 from "./jclist.vue?vue&type=style&index=0&id=135d3d21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d3d21",
  null
  
)

export default component.exports